import Space from 'antd/lib/space';
import type { StyledComponent } from 'styled-components';
import styled from 'styled-components';

export const StyledSpace: StyledComponent<typeof Space, any> = styled(Space)`
  &.ant-space-compact {
    .ant-form-item {
      margin-left: 0;
    }
  }
`;
